'use client';

import AppContext from '@/components/AppContext';
import { useTranslation } from '@/app/i18n/client';
import ButtonGroup from '@mui/material/ButtonGroup';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Link from 'next/link';
import { useContext } from 'react';
import Copyright from '@/components/Copyright';
import Logo from '@/components/Logo';
import Toolbar from '@mui/material/Toolbar';
import LocaleSwitcher from '@/components/LocaleSwitcher';
import ThemeSwitcher from '@/components/ThemeSwitcher';

export default function Home() {
  const app = useContext(AppContext);
  const { t } = useTranslation(app.i18n.lng);

  return (
    <Container maxWidth="md">
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'start',
          alignItems: 'center',
          minHeight: '100vh',
        }}
      >
        <Toolbar disableGutters sx={{ alignSelf: 'stretch' }}>
          <Box sx={{ flexGrow: 1, display: 'flex' }}></Box>

          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              flexGrow: 0,
              flexWrap: 'nowrap',
            }}
          >
            <LocaleSwitcher size="small" sx={{ mr: 1 }} />
            <ThemeSwitcher menu size="small" />
          </Box>
        </Toolbar>

        <Box
          sx={{
            my: 4,
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Typography variant="h4" component="h1" gutterBottom>
            <Logo margin="12" />
          </Typography>
        </Box>
        <Box
          sx={{
            my: 4,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'stretch',
          }}
        >
          <Typography variant="subtitle1" gutterBottom component={'p'}>
            Ventor Energi Norge, Isonor Polska oraz Ventigros przywiązują
            szczególną uwagę do zachowania zasad etyki i społecznej
            odpowiedzialności biznesu wewnątrz organizacji. W związku z tym
            udostępniamy narzędzia i zachęcamy naszych pracowników, partnerów
            biznesowych i interesariuszy zewnętrznych z którymi współpracujemy
            do zgłaszania zdarzeń niepożądanych, a także podejrzeń i wątpliwości
            dotyczących naruszenia zasad lub polityki firmy.
          </Typography>
          <Typography variant="body1">
            Pracowników naszych spółek zachęcamy do natychmiastowego zgłaszania
            problemów swojemu przełożonemu, kierownictwu najwyższego szczebla
            lub pracownikom, których obowiązkiem jest monitorowanie zgłoszonych
            incydentów.
          </Typography>
          <Typography variant="body1">
            Naruszenia można zgłaszać także anonimowo wysyłając nam poufny
            raport dostępny na stronie internetowej. Po wypełnieniu formularza
            raportu otrzymasz unikatowy kod zwany "kluczem raportu". Zapamiętaj
            go wraz z ustalonym przez Ciebie hasłem. Klucz raportu oraz hasło
            umożliwi Ci anonimową komunikację z nami w sprawie Twojego
            zgłoszenia.
          </Typography>
          <Typography variant="body1" component={'span'}>
            Zgłoszenia mogą dotyczyć m.in:
            <ul>
              <li>Nękania, mobbingu lub dyskryminacji</li>
              <li>Konfliktu interesów</li>
              <li>Nieuczciwej konkurencji</li>
              <li>Naruszenie przepisów ochrony środowiska</li>
              <li>Korupcji</li>
              <li>Potencjalnych zagrożeń bezpieczeństwa</li>
              <li>Naruszenia poufności</li>
              <li>Wykorzystywania informacji poufnych</li>
            </ul>
          </Typography>
          <Typography variant="body1">
            Formularz dostępny jest przez całą dobę.
          </Typography>
          <Box
            sx={{
              my: 4,
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <Box maxWidth="sm">
              <ButtonGroup
                variant="contained"
                size="large"
                sx={{ textAlign: 'center' }}
              >
                <Button component={Link} href="report/">
                  {t('Report an incident')}
                </Button>
                <Button component={Link} href="follow/">
                  {t('Follow up on a report')}
                </Button>
              </ButtonGroup>
            </Box>
          </Box>
        </Box>

        <Box
          sx={{
            mt: 'auto',
          }}
        >
          <Box sx={{ mt: 2, mb: 6 }}>
            <Copyright />
          </Box>
        </Box>
      </Box>
    </Container>
  );
}
